<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/foVjRU/tc-custom/9781426826344.jpg?1718183631658" alt="This image is the cover for the book Italian Prince, Wedlocked Wife, Red-Hot Revenge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Italian Prince, Wedlocked Wife, Red-Hot Revenge
      </h1>
      <p class="bookDescription body article font2">
        <b>A prince marries a woman for revenge, only to discover he still loves her in this sexy international romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>Single mom Lucy Abbott is working as many hours as she can, but still can barely afford to feed her baby daughter.<br/><br/>Then Prince Maximo d’Aquilla offers her millions, and a way out of her desperate life. Max whisks her away to Italy—and soon she’s totally his!<br/><br/>Max has seduced her completely. But is he driven by revenge, or desire? And is he ruthless enough to walk away from his captive bride?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennie Lucas
      </h2>
      
      <p class="authorDescription body article">Jennie Lucas's parents owned a bookstore and she grew up surrounded by books, dreaming about faraway lands. At twenty-two she met her future husband and after their marriage, she graduated from university with a degree in English. She started writing books a year later. Jennie won the Romance Writers of America&rsquo;s Golden Heart contest in 2005 and hasn&rsquo;t looked back since. Visit Jennie&rsquo;s website at: www.jennielucas.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c4000eb